import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import BrTooltip from '@components/BrTooltip';

// Handle special date due to historical backfill issue
// For blank or before 2009 or 12/31/2012, change to 11/7/2016*.
// Upon hover, we will show user “Created on or before 11/7/2016”.
const BR_INCEPTION = moment('2009-01-01');
const ODD_YEAREND_TIMESTAMP = 1356998400000;
const BACKFILL_DATE = moment('2016-11-07');

export default function DateColumn({ col, cell }) {
  const { value, locale } = cell;
  const { tooltip } = col.columnConfig || {};
  const dateFormat = locale === 'en_US' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';

  if (value) {
    const date = moment(value);
    // eslint-disable-next-line eqeqeq
    if (date > BR_INCEPTION && value != ODD_YEAREND_TIMESTAMP) {
      return date.format(dateFormat);
    }
    // backfill if no proper value given
    const backfillDate = BACKFILL_DATE.format(dateFormat);
    return (
      <BrTooltip>
        {backfillDate}
        *
        <BrTooltip.Tooltip>{`${tooltip} ${backfillDate}`}</BrTooltip.Tooltip>
      </BrTooltip>
    );
  }
  return null;
}

DateColumn.propTypes = {
  col: PropTypes.shape({
    // column config
    columnConfig: PropTypes.shape({
      tooltip: PropTypes.any,
    }),
  }).isRequired,
  cell: PropTypes.shape({
    value: PropTypes.any,
    locale: PropTypes.string,
  }).isRequired,
};
